(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-cable-pair"]) return;
  try {
    
  if (!customElements.get('th-cable-pair-offer')) {
    customElements.define('th-cable-pair-offer', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timer);
        this.controller = new AbortController();
        const refresh = () => this.syncExpiry();
        window.addEventListener('pageshow', refresh, { signal: this.controller.signal });
        document.addEventListener('visibilitychange', refresh, { signal: this.controller.signal });
        this.syncExpiry();
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timer);
      }
      syncExpiry() {
        clearTimeout(this.timer);
        const deadline = Number(this.dataset.offerDeadline) * 1000;
        const remaining = deadline - Date.now();
        if (Number.isFinite(deadline) && remaining > 0) {
          this.timer = setTimeout(() => this.syncExpiry(), Math.min(remaining, 2147483647));
          return false;
        }
        const offerPrice = this.querySelector('[data-pair-offer-pricing]');
        const regularPrice = this.querySelector('[data-pair-standard-pricing]');
        const action = this.querySelector('[data-pair-action]');
        const ended = this.querySelector('[data-pair-ended]');
        const browse = this.querySelector('[data-pair-ended-browse]');
        if (offerPrice) offerPrice.hidden = true;
        if (regularPrice) regularPrice.hidden = false;
        this.querySelectorAll('[data-pair-active-note], [data-pair-preview-note]').forEach((element) => { element.hidden = true; });
        if (ended) ended.hidden = false;
        if (browse) browse.hidden = false;
        if (action) {
          const hadFocus = action.contains(document.activeElement);
          action.querySelectorAll('input, button').forEach((element) => { element.disabled = true; });
          action.hidden = true;
          if (hadFocus && ended) ended.focus({ preventScroll: true });
        }
        return true;
      }
    });
  }
  if (!customElements.get('th-cable-pair-form')) {
    customElements.define('th-cable-pair-form', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.form = this.querySelector('form');
        this.button = this.querySelector('button');
        this.status = this.querySelector('[data-pair-status]');
        this.review = this.querySelector('[data-pair-review]');
        this.form?.addEventListener('submit', (event) => this.addPair(event), { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      async addPair(event) {
        event.preventDefault();
        if (this.pending || this.completed) return;
        const offer = this.closest?.('th-cable-pair-offer');
        if (offer?.syncExpiry()) return;
        const data = new FormData(this.form);
        const items = [0, 1].map((index) => ({ id: Number(data.get(`items[${index}][id]`)), quantity: Number(data.get(`items[${index}][quantity]`)) }));
        if (items.some((item) => !Number.isSafeInteger(item.id) || item.id <= 0 || item.quantity !== 1) || items[0].id === items[1].id) {
          this.showError();
          return;
        }
        const submissionController = this.controller;
        this.pending = true;
        this.button.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.adding;
        this.review.hidden = false;
        let waitTimer;
        try {
          const request = fetch(`${this.form.action}.js`, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          }).then(async (response) => {
            const result = await response.json();
            if (!response.ok || !Array.isArray(result.items) || !items.every((item) => result.items.some((added) => Number(added.variant_id || added.id) === item.id && Number(added.quantity) >= item.quantity))) throw new Error('pair-unconfirmed');
          });
          await Promise.race([
            request,
            new Promise((_, reject) => {
              waitTimer = setTimeout(() => reject(new Error('pair-unconfirmed')), 20000);
            })
          ]);
          if (!this.isConnected || this.controller !== submissionController) {
            this.showError(false);
            return;
          }
          this.completed = true;
          this.status.textContent = this.dataset.success;
          this.review.hidden = false;
          window.location.assign(this.dataset.cartUrl);
        } catch {
          this.showError(this.controller === submissionController);
        } finally {
          clearTimeout(waitTimer);
          this.pending = false;
          this.form.removeAttribute('aria-busy');
        }
      }
      showError(focus = true) {
        this.completed = true;
        this.button.disabled = true;
        this.status.textContent = this.dataset.error;
        this.review.hidden = false;
        if (focus && this.isConnected) this.status.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-everyday-home"] && !Shopify.designMode) return;
  try {
    
function updateWeeklySale(){document.querySelectorAll('[data-sale-end]').forEach(timer=>{const remaining=Date.parse(timer.dataset.saleEnd)-Date.now();if(remaining<=0){location.reload();return;}const minutes=Math.floor(remaining/60000);timer.querySelector('[data-sale-days]').textContent=String(Math.floor(minutes/1440)).padStart(2,'0');timer.querySelector('[data-sale-hours]').textContent=String(Math.floor(minutes/60)%24).padStart(2,'0');timer.querySelector('[data-sale-minutes]').textContent=String(minutes%60).padStart(2,'0');});}updateWeeklySale();setInterval(updateWeeklySale,1000);

function initEveryday(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const form=root.querySelector('[data-finder]');if(!form)return;
 const config=JSON.parse(root.querySelector('[data-finder-config]').textContent);
 const result=form.querySelector('[data-finder-result]');
 function update(){const power=form.elements.task.value==='power';form.querySelector('[data-connector-field]').hidden=power;form.querySelector('[data-wireless-field]').hidden=!power;result.hidden=true;}
 form.addEventListener('change',update);
 form.addEventListener('submit',event=>{event.preventDefault();const data=new FormData(form);const task=data.get('task'),country=data.get('destination');let message=config.strings.unknown;let url='';
 if(task==='ports'||task==='power'){
 if(country==='unknown')message=config.strings.destination;
 else if(country!=='US')message=config.strings.other;
 else if(task==='ports'){
 const connector=data.get('connector');if(connector==='unknown')message=config.strings.connector;
 else{const variant=config.hubVariants.find(v=>v.title.includes(connector)&&v.available);if(variant){message=config.strings.hub;url=config.hubUrl+'?variant='+variant.id;}else message=config.strings.unavailable;}
 }else if(data.get('wireless')==='no')message=config.strings.noWireless;
 else if(data.get('wireless')!=='yes')message=config.strings.wireless;
 else if(config.bankAvailable){message=config.strings.bank;url=config.bankUrl;}
 else message=config.strings.unavailable;
 }
 result.replaceChildren();const p=document.createElement('p');p.textContent=message;result.append(p);if(url){const a=document.createElement('a');a.href=url;a.textContent=config.strings.view;result.append(a);}const support=document.createElement('a');support.href='/pages/contact';support.textContent=config.strings.ask;result.append(support);if(task==='ports'&&data.get('connector')==='unknown'){const guide=document.createElement('a');guide.href='#eh-connectors';guide.textContent=config.strings.connectorLink||'Compare connector photos';result.append(guide);}result.hidden=false;
 });update();
}
document.querySelectorAll('[data-everyday-home]').forEach(initEveryday);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-everyday-home]').forEach(initEveryday));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-premium-home"] && !Shopify.designMode) return;
  try {
    
  const updateTechHonestyWeeklyCountdown = () => {
    document.querySelectorAll('[data-weekly-deal-countdown]').forEach((timer) => {
      const output = timer.querySelector('[data-weekly-deal-time]');
      const end = new Date(timer.dataset.weeklyDealEnd);
      if (!output || Number.isNaN(end.getTime())) return;

      const remaining = end.getTime() - Date.now();
      if (remaining <= 0) {
        output.innerHTML = '<span><b>00</b><em>Days</em></span><span><b>00</b><em>Hrs</em></span><span><b>00</b><em>Mins</em></span><span><b>00</b><em>Secs</em></span>';
        timer.setAttribute('aria-label', 'Weekly deal ended');
        return;
      }

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      output.innerHTML = [
        `<span><b>${String(days).padStart(2, '0')}</b><em>Days</em></span>`,
        `<span><b>${String(hours).padStart(2, '0')}</b><em>Hrs</em></span>`,
        `<span><b>${String(minutes).padStart(2, '0')}</b><em>Mins</em></span>`,
        `<span><b>${String(seconds).padStart(2, '0')}</b><em>Secs</em></span>`
      ].join('');
    });
  };

  updateTechHonestyWeeklyCountdown();
  setInterval(updateTechHonestyWeeklyCountdown, 1000);

  } catch(e) { console.error(e); }
})();
})();
